import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Button, Stack, Row, Col } from 'react-bootstrap';
import { useGetAdvertisementQuery } from 'services';
import JobCardSkeleton from 'components/Common/Skeleton/JobCardSkeleton';
import useCommonStore, { setModalConfig } from 'store/common';
import AdvertisementBlock from 'components/AdvertisementBlock';
import { dataLimits } from 'constants';
import PaginationBox from 'components/PaginationBox';
import useTranslate from 'hooks/useTranslate';
import './styles.scss';

const Advertisement: React.FC = () => {
	const { translate } = useTranslate();
	const [activeKey, setActiveKey] = useState<string>('active');
	const [tabData, setTabData] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const { hideCommonModal }: any = useCommonStore((state) => state);

	const paramsQuery = `order=DESC&page=${currentPage}&limit=${dataLimits?.advertisement}`;
	const {
		data: { docs: advertisementData = [], meta = {} } = {},
		refetch: refetch,
		isPending,
	} = useGetAdvertisementQuery({ activeKey, paramsQuery });

	const [forceRefetchQuery, setForceRefetchQuery] = useState(false);

	useEffect(() => {
		if (activeKey) {
			setCurrentPage(1);
		}
	}, [activeKey]);

	useEffect(() => {
		refetch();
	}, [currentPage, activeKey, refetch, forceRefetchQuery]);

	const handleModalClose = () => {
		setCurrentPage(1);
		hideCommonModal();
		setForceRefetchQuery(!forceRefetchQuery);
	};

	const onAddButtonHandler = () => {
		setModalConfig({
			visible: true,
			type: 'addAdvertisement',
			onClose: handleModalClose,
		});
	};

	useEffect(() => {
		if (!isPending) {
			setTabData(advertisementData || []);
		}
	}, [advertisementData, isPending]);

	return (
		<div className="advertisement-tabs">
			<div className="white-box bg-white">
				<Stack className="gap-4">
					<div className="jobs-filter d-flex align-items-center justify-content-between">
						<p className="fw-semibold mb-0">{translate('Advertisement.header')}</p>
						<Button className="filled-btn rounded-pill" onClick={() => onAddButtonHandler()}>
							{translate('Common.purchase')}
						</Button>
					</div>
					<div className="connections-tab">
						<Tabs defaultActiveKey={activeKey} onSelect={(k) => setActiveKey(k!)}>
							<Tab eventKey="active" title={translate('Common.active')}>
								{activeKey === 'active' && isPending ? (
									<JobCardSkeleton />
								) : (
									<Row>
										{tabData?.length > 0 ? (
											<>
												{tabData.map((ad: any, index: number) => (
													<Col key={index} xxl={4} md={6}>
														<AdvertisementBlock data={ad} activeKey={activeKey} refetch={refetch} />
													</Col>
												))}
												{meta?.totalDocs > meta?.limit && (
													<PaginationBox
														totalData={meta?.totalDocs}
														limit={meta?.limit}
														page={meta?.page}
														setCurrentPage={setCurrentPage}
													/>
												)}
											</>
										) : (
											<Col>
												<Stack className="posted-job-box">
													<p className="mb-0">{translate('Common.noDataFound')}</p>
												</Stack>
											</Col>
										)}
									</Row>
								)}
							</Tab>
							<Tab eventKey="history" title={translate('Common.history')}>
								{activeKey === 'history' && isPending ? (
									<JobCardSkeleton />
								) : (
									<Row>
										{tabData?.length > 0 ? (
											<>
												{tabData.map((ad: any, index: number) => (
													<Col key={index} xxl={4} md={6}>
														<AdvertisementBlock data={ad} activeKey={activeKey} refetch={refetch} />
													</Col>
												))}
												{meta?.totalDocs > meta?.limit && (
													<PaginationBox
														totalData={meta?.totalDocs}
														limit={meta?.limit}
														page={meta?.page}
														setCurrentPage={setCurrentPage}
													/>
												)}
											</>
										) : (
											<Col>
												<Stack className="posted-job-box">
													<p className="mb-0">{translate('Common.noDataFound')}</p>
												</Stack>
											</Col>
										)}
									</Row>
								)}
							</Tab>
						</Tabs>
					</div>
				</Stack>
			</div>
		</div>
	);
};

export default Advertisement;
